<template>
    <div class="field">
        <label class="label">{{ translate("bracket_seeding") }}:</label>
        <div class="control">
            <div class="select">
                <select v-model="model">
                    <option :value="BracketSeedingTypeEnum.ByRankingAndAcademy">
                        {{ translate("admin_create_bracket.by_ranking_and_academy") }}
                    </option>
                    <option :value="BracketSeedingTypeEnum.ByAcademy">
                        {{ translate("admin_create_bracket.by_academy") }}
                    </option>
                    <option :value="BracketSeedingTypeEnum.ByAcademyRandomized">
                        {{ translate("admin_create_bracket.by_academy_randomized") }}
                    </option>
                    <option :value="BracketSeedingTypeEnum.ByAssignedSpot">
                        {{ translate("admin_create_bracket.by_assigned_spot") }}
                    </option>
                </select>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { translate } from "../Common/translations";
    import { BracketSeedingTypeEnum } from "../Common/types";
    const model = defineModel({ default: BracketSeedingTypeEnum.ByRankingAndAcademy });
</script>

<style scoped></style>
